export const COMPANY = {
  name: "Ecomold Clean",
  phone: "(416)-461-2686",
  phoneHref: "tel:+14164612686",
  email: "ecomoldclean@gmail.com",
  location: "Toronto & GTA, Ontario",
  tagline: "Healthy homes, cleaner air.",
  logo: "/ecomold-logo.png",
};

export const LICENCES = [
  {
    name: "IICRC",
    gold: true,
    note: "Governing body for AMRT & WRT",
  },
  {
    name: "AMRT",
    note: "Applied Microbial Remediation Technician",
  },
  {
    name: "WHMIS",
    suffix: "(Trained)",
    note: "Workplace Hazardous Materials Information System",
  },
  {
    name: "WRT",
    note: "Water Restoration Technician",
  },
];

export const SERVICES = [
  {
    key: "inspection",
    title: "Mold Inspection",
    short: "Thorough visual & moisture assessment",
    description:
      "Our certified technicians walk through your home, map moisture sources, and deliver a clear report with actionable next steps.",
    icon: "SearchCheck",
    image:
      "https://customer-assets.emergentagent.com/job_clean-mold-toronto/artifacts/sdy31lr6_IMAGE%202026-04-23%2011%3A51%3A42.jpg",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    key: "removal",
    title: "Mold Removal & Remediation",
    short: "Containment, HEPA filtration, safe disposal",
    description:
      "IICRC-aligned remediation with negative air containment, antimicrobial treatment, and sealed material disposal.",
    icon: "ShieldCheck",
    image:
      "https://images.pexels.com/photos/15591111/pexels-photo-15591111.jpeg",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "zones",
    title: "Attic, Basement & Bathroom Mold",
    short: "The three highest-risk zones in GTA homes",
    description:
      "Specialized protocols for humid basements, condensation-heavy attics, and recurring bathroom colonies.",
    icon: "Home",
    image:
      "https://images.unsplash.com/photo-1623955277601-2aa7bb3fb240?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGVtcHR5JTIwYmFzZW1lbnR8ZW58MHx8fHwxNzc2ODE3NTk0fDA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-1 md:row-span-1",
  },
  {
    key: "verification",
    title: "Post-Remediation Verification",
    short: "Independent walkthrough & sign-off",
    description:
      "We verify that the job is done right with a final inspection and a written completion certificate for your records.",
    icon: "BadgeCheck",
    image: null,
    span: "md:col-span-2 md:row-span-1",
  },
];

export const PROCESS = [
  {
    step: "01",
    title: "Inspect",
    description:
      "On-site visual assessment, moisture mapping, and humidity diagnostics.",
    icon: "Search",
  },
  {
    step: "02",
    title: "Contain",
    description:
      "Seal the affected area, set up negative air, and protect the rest of your home.",
    icon: "ShieldAlert",
  },
  {
    step: "03",
    title: "Remediate",
    description:
      "HEPA filtration, safe removal of contaminated materials, and antimicrobial treatment. We use Health Canada–registered disinfectants and professional-grade labeled products.",
    icon: "ShieldCheck",
  },
  {
    step: "04",
    title: "Verify",
    description:
      "Final walkthrough and a written completion certificate confirming the job is done right.",
    icon: "BadgeCheck",
  },
];

export const SERVICE_AREAS = [
  "Toronto",
  "Mississauga",
  "Brampton",
  "Scarborough",
  "North York",
  "Etobicoke",
  "Vaughan",
  "Markham",
  "Richmond Hill",
  "Oakville",
  "Burlington",
  "Ajax",
  "Pickering",
  "Whitby",
  "Oshawa",
  "Newmarket",
];

export const FAQS = [
  {
    q: "How do I know if I have a mold problem?",
    a: "Musty smells, visible dark spots on walls or ceilings, recurring respiratory symptoms, and a history of water damage are all signs. A professional inspection removes the guesswork.",
  },
  {
    q: "Do you offer free inspections?",
    a: "Our inspection carries a small service fee — but if mold is confirmed and you book the remediation with us on the same visit, the inspection fee is fully waived. You only pay for the cleaning job.",
  },
  {
    q: "Is mold remediation covered by home insurance?",
    a: "It depends on the cause. Mold resulting from a 'sudden and accidental' covered peril (e.g. a burst pipe) is often covered. We can provide reports to support your claim.",
  },
  {
    q: "How long does a typical remediation take?",
    a: "Most residential jobs take 1–3 days depending on area size, material involvement, and drying requirements. We give you an accurate timeline after the inspection.",
  },
  {
    q: "Are you licensed and certified?",
    a: "Yes — Ecomold Clean is IICRC-certified with AMRT (Applied Microbial Remediation Technician) and WRT (Water Restoration Technician) credentials, plus WHMIS (Trained) for hazardous materials handling. We also carry full liability insurance.",
  },
];
